import api from "../../index";

export const AddUpdateInvoiceTemplateApi = (data) => api.post('addupdateinvoicetemplete', data);
export const DeleteInvoiceTemplateApi = (data) => api.post('deleteinvoicetemplate', data);
export const GetInvoiceTemplateListApi = () => api.post('invoicetemplatelist');